// utils

// components
import FAQQuestions from "@components/faq/FAQQuestions";

import faq from "@db/faq";

const FAQ = () => {
  return (
    <>
      <main>
        <FAQQuestions data={faq} />
      </main>
    </>
  );
};

export default FAQ;
